<template>
  <div
      class="collapse navbar-collapse w-auto h-auto h-100"
      id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
<!--        <sidenav-item-->
<!--            url="/"-->
<!--            :class="getRoute() === 'dashboard' ? 'active' : ''"-->
<!--            :navText="'Главная'"-->
<!--        >-->
<!--          <template v-slot:icon>-->
<!--            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>-->
<!--          </template>-->
<!--        </sidenav-item>-->
        <sidenav-item
            url="/products"
            :class="getRoute() === 'tables' ? 'active' : ''"
            :navText="'Товары'"
        ></sidenav-item>
        <sidenav-item
            url="/clients"
            :class="getRoute() === 'tables' ? 'active' : ''"
            :navText="'Клиенты'"
        ></sidenav-item>
        <sidenav-item
            url="/"
            :class="getRoute() === 'tables' ? 'active' : ''"
            :navText="'Заказы'"
        ></sidenav-item>
        <sidenav-item
            url="/sales"
            :class="getRoute() === 'tables' ? 'active' : ''"
            :navText="'Продажи'"
        ></sidenav-item>
        <sidenav-item
            url="/black-list"
            :class="getRoute() === 'tables' ? 'active' : ''"
            :navText="'Черный список'"
        ></sidenav-item>
        <sidenav-item
            url="/repair"
            :class="getRoute() === 'tables' ? 'active' : ''"
            :navText="'Ремонт'"
        ></sidenav-item>
        <sidenav-item
            url="/discount"
            :class="getRoute() === 'tables' ? 'active' : ''"
            :navText="'Скидки'"
        ></sidenav-item>
      </li>
<!--      <li class="nav-item">-->
<!--        <a class="nav-link" @click="isOpen = !isOpen">-->
<!--          <i class="ni ni-book-bookmark text-warning text-sm opacity-10"></i>-->
<!--          <span class="nav-link-text">Справочники</span>-->
<!--          <i :class="['ni', 'ni-bold-down', isOpen ? 'rotate-icon' : '', 'text-black', 'text-sm', 'opacity-10', 'thin-arrow']"></i>-->
<!--        </a>-->
<!--        <transition name="list">-->
<!--        <div v-show="isOpen">-->
<!--          <sidenav-item-->
<!--              url="/products"-->
<!--              :class="getRoute() === 'tables' ? 'active' : ''"-->
<!--              :navText="'Товары'"-->
<!--          ></sidenav-item>-->
<!--          <sidenav-item-->
<!--              url="/clients"-->
<!--              :class="getRoute() === 'tables' ? 'active' : ''"-->
<!--              :navText="'Клиенты'"-->
<!--          ></sidenav-item>-->
<!--          <sidenav-item-->
<!--              url="/orders"-->
<!--              :class="getRoute() === 'tables' ? 'active' : ''"-->
<!--              :navText="'Заказы'"-->
<!--          ></sidenav-item>-->
<!--        </div>-->
<!--        </transition>-->
<!--      </li>-->
      <li class="mt-3 nav-item">
        <h6 class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 ms-2">
          Аккаунт
        </h6>
      </li>
      <li class="nav-item">
        <sidenav-item
            url="/signin"
            :class="getRoute() === 'signin' ? 'active' : ''"
            :navText="'Выйти'"
        >
          <template v-slot:icon>
            <i class="ni ni-single-copy-04 text-danger text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
    </ul>
  </div>
</template>

<script>
import SidenavItem from "./SidenavItem.vue";

export default {
  name: "SidenavList",
  props: {
    cardBg: String
  },
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: "active",
      isOpen: false,
    };
  },
  components: {
    SidenavItem,
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    }
  }
};
</script>

<style scoped>
.rotate-icon {
  transform: rotate(180deg);
  transform-origin: center;
  transition: transform 0.3s ease-in-out;
}
.text-black {
  color: #67748e !important;
}
.thin-arrow {
  margin-left: 10px;
  text-align: center;
}

.list-enter-active, .list-leave-active {
  transition: opacity 0.5s;
}
.list-enter, .list-leave-to {
  opacity: 0;
}

</style>
